export enum IssuanceTrigger {
  OnCompletion = 'ON_COMPLETION',
  OnDueDateIfEligible = 'ON_DUE_DATE_IF_ELIGIBLE',
}

export enum IssuanceMode {
  Automatic = 'AUTOMATIC',
  ManualReview = 'MANUAL_REVIEW',
  UserActionRequired = 'USER_ACTION_REQUIRED',
}

export enum AudienceScope {
  Private = 'PRIVATE',
  InvitedMembers = 'INVITED_MEMBERS',
  SelectedGroups = 'SELECTED_GROUPS',
  AllMembers = 'ALL_MEMBERS',
}

export enum CompletionItemType {
  Card = 'CARD',
  Playlist = 'PLAYLIST',
}

export enum CompletionGroupOperator {
  And = 'AND',
  Or = 'OR',
}

export enum CompletionRequirementType {
  Specific = 'SPECIFIC_REQUIREMENT',
  Minimum = 'MINIMUM_REQUIREMENT',
  Points = 'POINTS_REQUIREMENT',
}

export enum CompletionExpressionType {
  Atom = 'ATOM',
  Group = 'GROUP',
}

export enum CriteriaType {
  SingleLevel = 'SINGLE_LEVEL',
  MultiLevel = 'MULTI_LEVEL',
}

export enum BadgeShape {
  Shield = 'SHIELD',
  Circle = 'CIRCLE',
  Square = 'SQUARE',
}
